import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgMoreVertical} from "~/assets/svg/more-vertical.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmMoreVerticalIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgMoreVertical id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
